// extracted by mini-css-extract-plugin
module.exports = {"actueel":"actueel-module--actueel--3K2sv","buttons":"actueel-module--buttons--tx3di"};